<wiz-hgroup height="100%" width="100%" [wizDisabled]="owner.wizDisabled" verticalAlign="center">
  <wiz-label [wizLabel]="label" width="80%" [wizTextBehavior]="'truncate'"></wiz-label>
  
  <wiz-label [wizLabel]="kindLabel" width="20%" minWidth="50px" [wizTextBehavior]="'truncate'"></wiz-label>
  <wiz-hgroup #actionContainer height="100%" verticalAlign="center" horizontalAlign="end" width="65px">
    <span
    #blockBack
    [style.backgroundColor]="color"
    width="10px"
    height="10px"
    class="scen-round-mark"
    ></span>

    <!-- On utilise le click pour pouvoir faire un prevent -->
    <wiz-icon *ngIf="canAdd()" (click)="doAdd($event)" [wizTooltip]="'$.common.addchild.$'" >add</wiz-icon>
    <wiz-icon *ngIf="canDelete()" (click)="doDelete($event)" [wizTooltip]="'$.common.delete.$'" >close</wiz-icon>
    <wiz-spacer *ngIf="!canDelete()" width="16px" height="16px"></wiz-spacer>
  </wiz-hgroup>
</wiz-hgroup>
